/**
 * Утилиты для работы с ошибками API
 */

/**
 * Тип ошибки от axios
 */
interface AxiosError {
    response?: {
        data?: {
            message?: string;
        };
    };
    message?: string;
}

/**
 * Извлекает сообщение об ошибке из объекта ошибки API (axios)
 * @param error - Объект ошибки (может быть axios error или обычная ошибка)
 * @param defaultMessage - Сообщение по умолчанию, если не удалось извлечь сообщение
 * @returns Сообщение об ошибке
 */
export const getApiErrorMessage = (error: unknown, defaultMessage: string = 'Произошла ошибка'): string => {
    const err = error as AxiosError;
    return err.response?.data?.message ?? err.message ?? defaultMessage;
};
